import { deleteRaw, getRaw, postRaw, putRaw } from 'services/api';

export const EXPORT_URL = '/analytics/exportEvents';
export const AGGREGATE_CROSS_MEDIUM_STATS_FOR_TIMERANGE_URL = '/analytics/metrics/aggregate';
export const TIME_SERIES_DATA_URL = '/analytics/metrics/timeseries';
export const CAMPAIGNS_URL = '/analytics/getCampaignsForMetrics';
export const ALL_METRICS_FOR_CAMPAIGNS_URL = '/analytics/metrics/campaigns';
export const SEGMENTS_URL = '/analytics/segments';
export const SEGMENTSV2_URL = '/analytics/segmentsV2';
export const SET_INSIGHTS_FILTERS_URL = '/settings/project/setInsightsFilters';
export const GET_INSIGHTS_FILTERS_URL = '/settings/project/getInsightsFilters';
export const PREVIEW_THUMBNAILS_URL = '/templates/getPreviewThumbnails';
export const EXPORT_CAMPAIGNS_AS_CSV_URL = '/analytics/getCampaignMetricsCsv';
export const EXPORT_DESTINATIONS_AS_CSV_URL = '/analytics/getInAppDestinationMetricsCsv';
export const GET_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_URL = '/analytics/metrics/sort';
export const HEATMAP_TRACKING_ERRORS_URL = '/analytics/tracking/errors';

export const SAVED_VIEWS_URL = '/insights/views';
export const GET_SAVED_VIEWS = '/insights/views';

export const getCampaigns = (queryData) => {
  return postRaw(CAMPAIGNS_URL, queryData);
};

export const getAllMetricsForCampaigns = (queryData) => {
  return postRaw(ALL_METRICS_FOR_CAMPAIGNS_URL, queryData);
};

export const getSegments = (queryData) => {
  return postRaw(SEGMENTS_URL, queryData);
};

export const getSegmentsV2 = (queryData) => {
  return postRaw(SEGMENTSV2_URL, queryData);
};

export function exportEventReportAsCsv({ campaignIds, eventType, showAppPackage = false }) {
  if (showAppPackage) {
    return postRaw(EXPORT_URL, { campaignIds, eventType, showAppPackage });
  }
  return postRaw(EXPORT_URL, { campaignIds, eventType });
}

export const getXMedAggStatsForTimeRange = (queryData) => {
  return postRaw(AGGREGATE_CROSS_MEDIUM_STATS_FOR_TIMERANGE_URL, queryData);
};

export const getTimeSeriesData = (queryData) => {
  return postRaw(TIME_SERIES_DATA_URL, queryData);
};

export const getInsightsFilters = (queryData) => {
  return getRaw(GET_INSIGHTS_FILTERS_URL, queryData);
};

export const getPreviewThumbnails = ({ templateIds }) => {
  return getRaw(
    `${PREVIEW_THUMBNAILS_URL}${templateIds
      .map((templateId, idx) => `${idx !== 0 ? '&' : '?'}templateIds=${templateId}`)
      .join('')}`,
  );
};

export const exportCampaignsAsCsv = (queryData) => {
  return postRaw(EXPORT_CAMPAIGNS_AS_CSV_URL, queryData);
};

export const exportDestinationsAsCsv = (queryData) => {
  return postRaw(EXPORT_DESTINATIONS_AS_CSV_URL, queryData);
};

export const getSortedCampaignIdsByMultiMediumMetric = (queryData) => {
  return postRaw(GET_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_URL, queryData);
};

const requestHeaders = {
  headers: {
    'Content-Type': 'text/json',
  },
};

export const setInsightsFilters = (postData) => {
  return postRaw(SET_INSIGHTS_FILTERS_URL, { filterString: postData }, requestHeaders);
};

export const getSavedView = (viewId) => {
  return getRaw(`${SAVED_VIEWS_URL}/${viewId}`);
};

export const createView = (view) => {
  return postRaw(SAVED_VIEWS_URL, view);
};

export const updateView = (viewId, view) => {
  return putRaw(`${SAVED_VIEWS_URL}/${viewId}`, view);
};

export const getSavedViews = (queryParams) => {
  return getRaw(`${SAVED_VIEWS_URL}?${queryParams}`);
};

export const deleteSavedViews = (viewId) => {
  return deleteRaw(`${SAVED_VIEWS_URL}/${viewId}`);
};

export const fetchTrackingErrorsByContentId = (contentId) => {
  return getRaw(`${HEATMAP_TRACKING_ERRORS_URL}?contentId=${contentId}`);
};
